const ViewsFactory = require('public_framework/views_factory')

const Components = {
  Community: {
    AddToCalendar: require('./views/add_to_calendar'),
    Attendees: require('./views/attendees'),
    ContactLeader: require('./views/contact_leader'),
    SignUp: require('./views/sign_up')
  },
  Ui: {
    Dropdown: require('public_shared_components/ui/dropdown/views/dropdown'),
    Map: require('public_shared_components/ui/map/views/map'),
    Slider: require('public_shared_components/ui/slider/views/slider')
  },
  Shared: {
    SocialShare: require('public_shared_components/social_share')
  }
}

ViewsFactory.addComponents(Components)



// WEBPACK FOOTER //
// ./front/apps/public/pages/community_event/javascripts/index.js